import React, { useState } from 'react';
import axios from 'axios';
import { useWorkspace } from '../../../context/WorkspaceContext';
const BACKEND_API_URL = process.env.REACT_APP_BACKEND_API_URL;

const FacebookLoginButton = () => {
    const { idToken } = useWorkspace();
    const [isLoading, setIsLoading] = useState(false);

    const handleAuthClick = () => {
        setIsLoading(true);
        axios.get(BACKEND_API_URL + '/api/facebook/oauth', { headers: { Authorization: `Bearer ${idToken}` } })
            .then(response => {
                localStorage.setItem('social_auth_pending', 'facebook');
                window.open(response.data, '_blank');
                setIsLoading(false);
            })
            .catch(error => {
                console.log(error);
                setIsLoading(false);
            });
    };

    
    return (
        <button
            className="bg-blue-600 hover:bg-blue-700 h-[70px] p-4 rounded-lg flex items-center w-full justify-between"
            onClick={handleAuthClick}
            disabled={isLoading}
            data-scope="public_profile,email,instagram_basic"
        >
            {isLoading ? 'Loading...' : (
                <>
                    <div className="mr-3 w-12 h-12 bg-white rounded-full flex items-center justify-center">
                        <img
                            src={'../socials/facebook-logo.svg'}
                            alt="Facebook Logo"
                            className="w-8 h-8"
                        />
                    </div>
                    <p className="text-white font-bold">Facebook Pages</p>
                </>
            )}
            <div></div>
        </button>
    );
};

export default FacebookLoginButton;
